import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Clock, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function DelayedApprovalCard() {
  const [hours, setHours] = useState("");
  const [rem, setRem] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/approvals/delayed-config")
      .then((r) => { setHours(String(r.data.hours ?? 12)); setRem(String(r.data.reminder_hours ?? 24)); })
      .catch(() => { setHours("12"); setRem("24"); });
  }, []);

  const save = async () => {
    const v = parseInt(hours, 10);
    const rv = parseInt(rem, 10);
    if (!(v >= 1 && v <= 168)) return toast.error("SLA eşiği 1 ile 168 saat arası olmalı");
    if (!(rv >= 1 && rv <= 168)) return toast.error("Hatırlatma sıklığı 1 ile 168 saat arası olmalı");
    setSaving(true);
    try {
      const { data } = await api.put("/approvals/delayed-config", { hours: v, reminder_hours: rv });
      setHours(String(data.hours)); setRem(String(data.reminder_hours));
      toast.success("Geciken onay ayarları kaydedildi");
    } catch {
      toast.error("Kaydedilemedi");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="delayed-approval-card" className="space-y-3 rounded-lg bg-white p-5 ring-1 ring-inset ring-slate-200">
      <div className="flex items-center gap-2"><Clock className="h-5 w-5 text-brand-green" /><h2 className="font-heading text-lg font-semibold">Geciken Onay Hatırlatması (SLA)</h2></div>
      <p className="text-xs text-slate-500">SLA eşiğinden uzun bekleyen onaylar için yöneticilere otomatik hatırlatma (uygulama-içi bildirim + e-posta) gider. Hatırlatma, seçtiğiniz sıklıktan daha erken tekrarlanmaz — böylece ne onay unutulur ne de gereksiz bildirim yağar. Bu ayarlar tek yerden yönetilir.</p>
      <div className="flex flex-wrap items-end gap-3">
        <div>
          <label className="mb-1 block text-xs font-semibold text-slate-600">SLA eşiği (saat)</label>
          <input data-testid="delayed-approval-input" type="number" min="1" max="168" value={hours} onChange={(e) => setHours(e.target.value)} className="h-10 w-36 rounded-md border border-slate-300 px-3 text-sm tabular" placeholder="12" />
        </div>
        <div>
          <label className="mb-1 block text-xs font-semibold text-slate-600">Hatırlatma sıklığı (saat)</label>
          <input data-testid="delayed-reminder-input" type="number" min="1" max="168" value={rem} onChange={(e) => setRem(e.target.value)} className="h-10 w-36 rounded-md border border-slate-300 px-3 text-sm tabular" placeholder="24" />
        </div>
        <Button data-testid="delayed-approval-save" onClick={save} disabled={saving} className="bg-brand-green text-white hover:bg-brand-green-600">{saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Kaydet</Button>
        <button type="button" data-testid="delayed-approval-default" onClick={() => { setHours("12"); setRem("24"); }} className="text-xs font-semibold text-slate-500 hover:text-slate-800">Varsayılana dön</button>
      </div>
    </div>
  );
}
